import {atom} from "jotai";
import type {StudentsResult} from "@repo/actions/filterRelationsToStudents";

/**
 * Students attached to the logged-in parent. Hydrated from `getDiscoveryAuth`
 * outside `"use cache"` (header and course route) so cart, schedule add-to-cart,
 * and other client code can read a fresh roster without another fetch.
 * Empty when logged out, not a parent, or the fetch failed.
 */
export const parentStudentsAtom = atom<StudentsResult>([]);
